// extracted by mini-css-extract-plugin
module.exports = {"qasaButton":"QasaLandingPublishButton_qasaButton__GtNIt"};